import React from 'react';
import PropTypes from 'prop-types';

import { strings } from '../../../../localization';

import Switch from '../../../../components/common/Switch';
import ReactSlider from 'react-slider';
import styled from 'styled-components'; // styling react-slider
import ProgressOverlay from '../../../../components/common/ProgressOverlay';

import { UPDATE_SETTINGS_TIMEOUT } from '../GlobalSettings';

const HARD_BRAKING_THRESHOLD_MIN_G = -600 / 1000; // least sensitive (negative scale, inverted min/maxes) //-200 / 1000; // most sensitive
const HARD_BRAKING_THRESHOLD_MAX_G = -200 / 1000; // most sensitive (negative scale, inverted min/maxes) //-600 / 1000; // least sensitive
const HARD_BRAKING_THRESHOLD_RESOLUTION_STEP_G = 0.01;
const HARD_BRAKING_THRESHOLD_HELPER_G_PASSENGER_VEHICLE = -400 / 1000; // platform default
const HARD_BRAKING_THRESHOLD_HELPER_G_TRUCK_OR_VAR = -360 / 1000;
const HARD_BRAKING_THRESHOLD_HELPER_G_HEAVY_DUTY = -300 / 1000;

export default class EventsHardBraking extends React.PureComponent {

    static propTypes = {
        eventConfigAvailable: PropTypes.bool,
        eventAvailabilityPending: PropTypes.bool.isRequired,
        eventAvailabilityEnabled: PropTypes.bool,
        eventAvailabilityErrorMessage: PropTypes.string,
        applyEventAvailability: PropTypes.func.isRequired,
        timeoutEventAvailability: PropTypes.func.isRequired,

        eventThresholdPending: PropTypes.bool.isRequired,
        eventThreshold: PropTypes.number,
        eventThresholdErrorMessage: PropTypes.string,
        applyEventThreshold: PropTypes.func.isRequired,
        timeoutEventThreshold: PropTypes.func.isRequired,

        expandOrCollapseStateForUIReferences: PropTypes.func.isRequired,
        eventsHardBrakingExpandReference: PropTypes.string.isRequired,
        eventsHardBrakingExpandReferenceIsExpanded: PropTypes.bool.isRequired
    }

    constructor(props) {

        super(props);

        this.state = {
            eventThreshold: undefined,
            eventThresholdValidationMessage: undefined
        }

        this.applyEventAvailabilityTimeoutId = undefined;
        this.applyeventThresholdTimeoutId = undefined;
    }

    componentWillUnmount() {
        clearTimeout(this.applyEventAvailabilityTimeoutId);
        clearTimeout(this.applyeventThresholdTimeoutId);
    }

    /*componentDidUpdate(prevProps) {
    }*/


    discardEventThresholdChanges = () => {
        this.setState({
            eventThreshold: undefined,
            eventThresholdValidationMessage: undefined
        });
    }

    applyEventThresholdState = () => {

        clearTimeout(this.applyEventsThresholdTimeoutId);

        // validate this attempt to update car bumped threshold
        if (isNaN(this.state.eventThreshold)) { return; }

        const eventThresholdG = Number(this.state.eventThreshold);

        if (eventThresholdG > HARD_BRAKING_THRESHOLD_MAX_G) {
            eventThresholdG = HARD_BRAKING_THRESHOLD_MAX_G;
        } else if (eventThresholdG < HARD_BRAKING_THRESHOLD_MIN_G) {
            eventThresholdG = HARD_BRAKING_THRESHOLD_MIN_G;
        }
        let eventThresholdMilliG = eventThresholdG * 1000;

        this.props.applyEventThreshold(
            Number(eventThresholdMilliG), // new
            this.props.eventThreshold // old (for undo)
        )
        .then(
            () => {
                this.discardEventThresholdChanges(); // clear state to hide apply/discard buttons
                clearTimeout(this.applyEventsThresholdTimeoutId);
            },
            () => {clearTimeout(this.applyEventsThresholdTimeoutId)}
        )
    }

    handleThresholdChange = (event) => {

        let trimmedValue = event.target.value? event.target.value.trim() : null; // null is a special case (user has cleared the input, input should remain blank if null, render() and apply check for undefined only)

        if (trimmedValue === null) {
            this.setState({
                eventThreshold: trimmedValue // null is a special case (user has cleared the input, input should remain blank if null, render() and apply check for undefined only)
            });
            return;    
        }

        if (isNaN(trimmedValue)) { return; }

        let eventThresholdValidationMessage = undefined;
        if (Number(trimmedValue) < HARD_BRAKING_THRESHOLD_MIN_G) {
            eventThresholdValidationMessage = strings.formatString(strings.settings_global_events_threshold_needs_to_be_between_x_and_x_g, HARD_BRAKING_THRESHOLD_MIN_G, HARD_BRAKING_THRESHOLD_MAX_G);
        }

        if (Number(trimmedValue) > HARD_BRAKING_THRESHOLD_MAX_G) {
            eventThresholdValidationMessage = strings.formatString(strings.settings_global_events_threshold_needs_to_be_between_x_and_x_g, HARD_BRAKING_THRESHOLD_MIN_G, HARD_BRAKING_THRESHOLD_MAX_G);
        }

        this.setState({
            eventThreshold: trimmedValue, // saving milli-g to state for user input
            eventThresholdValidationMessage: eventThresholdValidationMessage
        });
    }


    render() {

        var showCarBumpedApplyButton = false;
        // if editing (if state version of ssid and password)
        if (this.state.eventThreshold !== undefined) {
            showCarBumpedApplyButton = true;
        }
        const formCarBumpedActionsClassName =  showCarBumpedApplyButton ? "form-actions" : "form-actions collapsed";

        let eventThreshold = ""; // RAV-1544 sanitizing "undefined"s becasue they will not clear values via state changes (discardWiFiCredentialsChanges() wouldn't work)
        if (this.props.eventThreshold !== undefined) {
            eventThreshold = this.props.eventThreshold / 1000; // convert from milli-g (cloud) to g
        }
        if (this.state.eventThreshold !== undefined) { // null is a special case (user has cleared the input, input should remain blank if null, render() and apply check for undefined only)
            eventThreshold = this.state.eventThreshold ? this.state.eventThreshold : "";
        }

        // react-slider styling
        const StyledSlider = styled(ReactSlider)`
            width: 100%;
            height: 24px;
        `;
        
        let styledThumbOpacity = this.state.eventThresholdValidationMessage ? 0.5 : 1.0;
        const StyledThumb = styled.div`
            height: 18px;
            line-height: 18px;
            width: 18px;
            margin: 3px 0 0 0;
            text-align: center;
            font-size: 0px;
            background-color: #FFF;
            color: #000;
            border-radius: 9px;
            cursor: grab;
            border: none;
            opacity: ${styledThumbOpacity};
        `;
        
        const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;
        
        const StyledTrack = styled.div`
            top: 0;
            bottom: 0;
            background: ${ (props) => {
                return '#999999'; // it is possible to apply branding here, but our current solution uses variables in SCSS (see _settings.scss for .slider-container .track)
            }};
            border-radius: 999px;
            margin: 0;
            padding: 0;
            border: none;
        `;
        
        const Track = (props, state) => <StyledTrack {...props} index={state.index} />;
        // end react-slider styling

        if (!this.props.eventConfigAvailable) {
            return null;
        }

        return (
            <div className='setting-group-horiz'>
                <div className={this.props.eventsHardBrakingExpandReferenceIsExpanded ? "subgroup" : "subgroup collapsed"}>
                    <h5 className="subgroup-header">
                        <button disabled={true} // SUBSECTION_COLLAPSING_DISABLED
                            className={this.props.eventsHardBrakingExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                            onClick={() => {
                                this.props.expandOrCollapseStateForUIReferences(
                                    !this.props.eventsHardBrakingExpandReferenceIsExpanded,
                                    [this.props.eventsHardBrakingExpandReference])
                            }}>
                            {strings.settings_global_events_hard_braking_header}
                            <i className="material-icons disclosure">keyboard_arrow_up</i>
                        </button>
                    </h5>

                    <h6 className="subgroup-subheader">
                        <div className='setting-group switch-group'>
                            <div>
                                <Switch
                                    onChange={() => {

                                        clearTimeout(this.applyEventAvailabilityTimeoutId);
                                        const eventAvailabilityEnabled = this.props.eventAvailabilityEnabled;
                                        this.applyEventAvailabilityTimeoutId = setTimeout(() => {this.props.timeoutEventAvailability(eventAvailabilityEnabled)}, UPDATE_SETTINGS_TIMEOUT);

                                        this.props.applyEventAvailability(!this.props.eventAvailabilityEnabled)
                                        .then(
                                            () => {clearTimeout(this.applyEventAvailabilityTimeoutId)},
                                            () => {clearTimeout(this.applyEventAvailabilityTimeoutId)}
                                        )
                                    }}
                                    checked={this.props.eventAvailabilityEnabled || false}
                                    disabled={this.props.eventAvailabilityPending}
                                    smallFormat={true}
                                />
                                <label disabled={this.props.eventAvailabilityPending}>{this.props.eventAvailabilityEnabled?
                                    strings.settings_global_events_hard_braking_are_enabled
                                :
                                    strings.settings_global_events_hard_braking_are_disabled
                                }</label>
                                {this.props.eventAvailabilityPending ? <ProgressOverlay /> : null }
                            </div>
                            <div className="error-message">
                                {this.props.eventAvailabilityErrorMessage}
                            </div>
                        </div>
                    </h6>
                    <div className='setting-group threshold-slider car-bumped'>
                        <div className="description">
                            {strings.settings_global_events_speeding_threshold_description}
                        </div>
                        <div className="form">
                            <div className="slider-input">
                                <input type="text" autoComplete="off" maxLength="5" className="threshold" value={eventThreshold} placeholder={strings.settings_global_events_speeding_threshold_placeholder} onChange={this.handleThresholdChange}></input>
                                <label>{strings.settings_global_events_g_units}</label>
                            </div>
                            <span className="label left">{strings.settings_global_slider_lable_most_sensitive}</span>
                            <div className="slider-container">
                                <StyledSlider
                                    defaultValue={[eventThreshold]}
                                    renderTrack={Track}
                                    renderThumb={Thumb}
                                    invert={true} // slide left-to-right from max-to-min, which is least sensitive to most sensitive
                                    min={HARD_BRAKING_THRESHOLD_MIN_G}
                                    max={HARD_BRAKING_THRESHOLD_MAX_G}
                                    step={HARD_BRAKING_THRESHOLD_RESOLUTION_STEP_G}
                                    onAfterChange={(value, change) => {
                                        this.handleThresholdChange({
                                            target: {
                                                value: String(value)
                                            }
                                        })
                                    }}
                                />
                                <div className="slider-helpers">
                                    <div className="helper-icon passenger" style={{
                                        left: "" +
                                            Math.abs(
                                                ((HARD_BRAKING_THRESHOLD_HELPER_G_PASSENGER_VEHICLE - HARD_BRAKING_THRESHOLD_MIN_G) /
                                                (HARD_BRAKING_THRESHOLD_MAX_G - HARD_BRAKING_THRESHOLD_MIN_G) // get relative position
                                                * 95.75) // make it percent (off by 3.25% due to some inaccuracy between this calculation and the slider extension)
                                                - 100 // invert (slider is inverted, max-to-min values)
                                            ) + // absolute value
                                            "%" // absolute positioning by percentage
                                    }}>
                                        <div className="demarcation-line"></div>
                                        <button title={strings.settings_global_vehicle_passenger} onClick={() => {this.handleThresholdChange({
                                            target: {
                                                value: String(HARD_BRAKING_THRESHOLD_HELPER_G_PASSENGER_VEHICLE)
                                            }
                                        })}}>
                                            <img src="/svg/material-symbol-car-side.svg" />
                                        </button>
                                    </div>
                                    <div className="helper-icon truck" style={{
                                        left: "" +
                                            Math.abs(
                                                ((HARD_BRAKING_THRESHOLD_HELPER_G_TRUCK_OR_VAR - HARD_BRAKING_THRESHOLD_MIN_G) /
                                                (HARD_BRAKING_THRESHOLD_MAX_G - HARD_BRAKING_THRESHOLD_MIN_G) // get relative position
                                                * 95.75) // make it percent (off by 3.25% due to some inaccuracy between this calculation and the slider extension)
                                                - 100 // invert (slider is inverted, max-to-min values)
                                            ) + // absolute value 
                                            "%" // absolute positioning by percentage
                                    }}>
                                        <div className="demarcation-line"></div>
                                        <button title={strings.settings_global_vehicle_truck_or_van} onClick={() => {this.handleThresholdChange({
                                            target: {
                                                value: String(HARD_BRAKING_THRESHOLD_HELPER_G_TRUCK_OR_VAR)
                                            }
                                        })}}>
                                            <img src="/svg/material-symbol-car-pickup.svg" />
                                        </button>
                                    </div>
                                    <div className="helper-icon heavy-duty" style={{
                                        left: "" +
                                            Math.abs(
                                                ((HARD_BRAKING_THRESHOLD_HELPER_G_HEAVY_DUTY - HARD_BRAKING_THRESHOLD_MIN_G) /
                                                (HARD_BRAKING_THRESHOLD_MAX_G - HARD_BRAKING_THRESHOLD_MIN_G) // get relative position
                                                * 95.75) // make it percent (off by 3.25% due to some inaccuracy between this calculation and the slider extension)
                                                - 100 // invert (slider is inverted, max-to-min values)
                                            ) + // absolute value 
                                            "%" // absolute positioning by percentage
                                    }}>
                                        <div className="demarcation-line"></div>
                                        <button title={strings.settings_global_vehicle_heavy_duty} onClick={() => {this.handleThresholdChange({
                                            target: {
                                                value: String(HARD_BRAKING_THRESHOLD_HELPER_G_HEAVY_DUTY)
                                            }
                                        })}}>
                                            <img src="/svg/material-symbol-dump-truck.svg" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <span className="label right">{strings.settings_global_slider_lable_least_sensitive}</span>
                        </div>
                        <div className={formCarBumpedActionsClassName}>
                            <button className="btn btn-blue" disabled={this.state.eventThresholdValidationMessage !== undefined} onClick={this.applyEventThresholdState}>{strings.action_apply}</button>
                            <button className="btn btn-outline-red" onClick={this.discardEventThresholdChanges}>{strings.settings_action_discard_changes}</button>
                        </div>
                        <div className="error-message form-indent">
                            {this.props.eventThresholdErrorMessage || this.state.eventThresholdValidationMessage}
                        </div>
                        {this.props.eventThresholdPending || this.props.eventAvailabilityPending ? <ProgressOverlay /> : null }
                    </div>
                </div>
            </div>
        );
    }
}